import React from 'react';
import styles from './StickyWrapper.module.scss';
export const StickyWrapper = ({ children }) => {
    return <div className={styles.sticky}>{children}</div>;
};
